var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 20.503V7.99783C5.5 6.34029 6.84371 4.99658 8.50125 4.99658H16.5046C18.1621 4.99658 19.5058 6.34029 19.5058 7.99783V20.503C19.506 20.6906 19.4012 20.8624 19.2345 20.9482C19.0677 21.034 18.867 21.0194 18.7145 20.9102L12.794 16.6804C12.62 16.5559 12.3859 16.5559 12.2118 16.6804L6.29133 20.9092C6.13898 21.0182 5.93847 21.033 5.77179 20.9475C5.60512 20.8619 5.50022 20.6904 5.5 20.503Z",
    stroke: "#616161",
    strokeWidth: 1.46875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.b3dd1e0e95d009da166850cd40cad05f.svg";
export { ForwardRef as ReactComponent };